import { IconDownSwicher, IconUpSwicher } from "./StylesIcon.styled";

export const IconDown = () => {
  return (
    <>
      <IconDownSwicher viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.904 26.092c0.122 0.178 0.286 0.323 0.477 0.423s0.403 0.153 0.619 0.153 0.428-0.052 0.619-0.153c0.191-0.1 0.355-0.246 0.477-0.423l12-17.333c0.139-0.2 0.22-0.434 0.235-0.677s-0.037-0.485-0.149-0.701-0.283-0.396-0.491-0.522c-0.208-0.126-0.447-0.192-0.691-0.192h-24c-0.243 0.001-0.481 0.068-0.688 0.194s-0.377 0.306-0.49 0.522c-0.113 0.215-0.165 0.457-0.15 0.699s0.095 0.476 0.232 0.677l12 17.333z" />
      </IconDownSwicher>
    </>
  );
};

export const IconUp = () => {
  return (
    <>
      <IconUpSwicher viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.999 25.333h24c0.243-0.001 0.481-0.068 0.689-0.194s0.377-0.306 0.49-0.521c0.113-0.215 0.165-0.457 0.151-0.7s-0.095-0.477-0.232-0.677l-12-17.333c-0.497-0.719-1.695-0.719-2.193 0l-12 17.333c-0.139 0.2-0.22 0.434-0.236 0.677s0.037 0.485 0.15 0.701c0.113 0.216 0.283 0.396 0.491 0.522s0.447 0.192 0.691 0.192z" />
      </IconUpSwicher>
    </>
  );
};
